export default "__VITE_ASSET__5I48xfsB__"